import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = []

const defaultSyntaxGuideUrl = ''

class SemanticScholarEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Semantic Scholar')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }

  formulateQuery (query) {
    return 'https://www.semanticscholar.org/search?q=' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default SemanticScholarEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/SemanticScholarEngine.js